import RecoveryWorkOrderCost from './RecoveryWorkOrderCost.vue'

export default RecoveryWorkOrderCost 


// WEBPACK FOOTER //
// ./src/pages/RecoveryWorkOrderCost/index.js